<template>
	<ViewLayout>
		<template #header-title>
			RoPA
		</template>
		<template #content>
			<slot name="content" />
		</template>
	</ViewLayout>
</template>
<script>
import ViewLayout from '../../../../../shared/layouts/view-layout.vue'
export default {
	components: { ViewLayout }
}
</script>
